import React, { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';

const ModalExcelVigilanciaEpidemilogica = ({setmodalOnExcelVP, dataVigilanciaEpidemiologica}) => {
    const [loading,setloading]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOnExcelVP(false)
    }

    useEffect(()=>{

    },[])

    const processDataToExcel=()=>{
        const processedData = [];
  
      // Añadir cabecera como objeto
      processedData.push({
          CodigoArchivo:'Codigo Archivo',
          numeroCama: 'Numero Cama',
          nombrePabellon: 'Nombre pabellon',
          paciente: 'Paciente',
          documento: 'Documento',
          sexo: 'Sexo',
          codigoDiagnostico: 'Codigo diagnostico',
          diagnostico: 'Diagnostico'
      });

      dataVigilanciaEpidemiologica.forEach(item => {
        processedData.push({
            CodigoArchivo: item.id,
            numeroCama: item.MPNumC,
            nombrePabellon: item.MPNomP,
            paciente: item.MPNOMC,
            documento: item.MPUced,
            sexo: item.MPSexo,
            codigoDiagnostico: item.MPUdx,
            diagnostico: item.DMNomb
        });
      });

      // Crear una hoja de trabajo usando objetos
      const ws = XLSX.utils.json_to_sheet(processedData, {skipHeader: true});
  
      // Ajustar el ancho de las columnas
      ws['!cols'] = [
          {wch: 10},
          {wch: 15},
          {wch: 30},
          {wch: 35},
          {wch: 15},
          {wch: 10},
          {wch: 15},
          {wch: 50},
      ];
  
      // Crear un nuevo libro de trabajo y agregar la hoja de trabajo
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "VigilanciaEpidemiologica");
  
      // Escribir el archivo Excel y desencadenar la descarga
      const exportFileName = "VigilanciaEpidemiologica.xlsx";
      XLSX.writeFile(wb, exportFileName);
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Mensaje
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="flex py-2 text-left">
              <div className="w-3/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Esta seguro de descargar en Excel Vigilancia epidemiológica!
                </label>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              onClick={() => processDataToExcel()}
              className="inline-block px-6 py-2.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Exportar a Excel
            </button>
            
          </div>
        </div>
      </div>
      {loading &&
      <div className="relative flex items-center justify-center h-screen">
      <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
          <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
              <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
              <p className="mt-4 text-lg">Cargando</p>
          </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
  </div>}
    </div>
  )
}

export default ModalExcelVigilanciaEpidemilogica